module.exports = __webpack_public_path__ + "static/media/gameWin.7740f435.wav";